import {
  GET_FILE_TYPES,
  GET_FILE_TYPES_FAIL,
  GET_FILE_TYPES_SUCCESS,
  ADD_NEW_FILE_TYPE,
  ADD_FILE_TYPE_SUCCESS,
  ADD_FILE_TYPE_FAIL,
  UPDATE_FILE_TYPE,
  UPDATE_FILE_TYPE_SUCCESS,
  UPDATE_FILE_TYPE_FAIL,
  DELETE_FILE_TYPE,
  DELETE_FILE_TYPE_SUCCESS,
  DELETE_FILE_TYPE_FAIL,
  
} from "./actionTypes";

export const getFileTypes = () => ({
  type: GET_FILE_TYPES,
})

export const getFileTypesSuccess = (fileTypes) => ({
  type: GET_FILE_TYPES_SUCCESS,
  payload: fileTypes,
})

export const getFileTypesFail = error => ({
  type: GET_FILE_TYPES_FAIL,
  payload: error,
})

export const addNewFileType = (fileType) => ({
  type: ADD_NEW_FILE_TYPE,
  payload: fileType,
})

export const addFileTypeSuccess = (fileType) => ({
  type: ADD_FILE_TYPE_SUCCESS,
  payload: fileType,
})

export const addFileTypeFail = error => ({
  type: ADD_FILE_TYPE_FAIL,
  payload: error,
})

export const updateFileType = (fileType) => ({
  type: UPDATE_FILE_TYPE,
  payload: fileType,
})

export const updateFileTypeSuccess = (fileType) => ({
  type: UPDATE_FILE_TYPE_SUCCESS,
  payload: fileType,
})

export const updateFileTypeFail = error => ({
  type: UPDATE_FILE_TYPE_FAIL,
  payload: error,
})

export const deleteFileType = (fileType) => ({
  type: DELETE_FILE_TYPE,
  payload: fileType,
})

export const deleteFileTypeSuccess = (fileType) => ({
  type: DELETE_FILE_TYPE_SUCCESS,
  payload: fileType,
})

export const deleteFileTypeFail = error => ({
  type: DELETE_FILE_TYPE_FAIL,
  payload: error,
})

